<template>
  <div class="panel-wrapper">
    <div class="scan-time-wrapper">
      <span v-if="showProvider" class="body-provider"><p>{{ providerText }}</p></span>
      <span class="date">{{ date }}</span>
      <span class="time">{{ time }}</span>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  name: 'ScanTime',
  props: {
    record: Object,
    showProvider: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dateObj() {
      return this.record ? new Date(this.record.created_at) : new Date();
    },
    providerText() {
      if (this.record === null) return 'unknown';
      return this.record.provider
        ? this.$t('mobileScan.mobile_scan')
        : this.$t('mobileScan.body_scanner');
    },
    date() {
      return new Intl.DateTimeFormat(i18n.locale, { month: 'short', day: '2-digit' }).format(
        this.dateObj
      );
    },
    time() {
      return new Intl.DateTimeFormat(i18n.locale, { timeStyle: 'short', hour12: false }).format(
        this.dateObj
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-wrapper {
  @apply flex flex-col w-full;
  align-items: center;
}
.scan-time-wrapper {
  @apply flex;
  font-size: 14px;
  font-weight: 500;
  .body-provider {
    @apply mx-2 px-2 font-bold;
    background: rgba(237, 239, 255, 0.8);
    border-radius: 12px;
    align-items: center;
  }
  .body-provider p {
    background: linear-gradient(270deg, #2245FF 0.85%, #4300D9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .date {
    text-transform: uppercase;
  }
  .time {
    @apply mx-2;
    color: #8c8c8c;
  }
}
</style>
